/**
 * @desc 导出工厂散货订舱管理-> 提货信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(crno: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterFactoryScattered/exportPickUpInvoice/${crno}`, {
      method: "GET",

      ...options,
    }),
  );
}
